import { DayHeaderContentArg } from '@fullcalendar/core';
import { Container, ListWeekContainer, MonthDay, MonthDayWrapper, WeekDay } from './DayHeaderStyle';

const DayHeader = (props: DayHeaderContentArg) => {
  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  const renderDayHeader = () => {
    switch (true) {
      case props.view.type === 'listWeek':
        return (
          <ListWeekContainer>
            <WeekDay $isToday={props.isToday} $isPast={props.isPast}>
              {days[props.date.getDay()]}
              <MonthDay>{`${props.date.getDate()}/${props.date.getMonth() + 1}`}</MonthDay>
            </WeekDay>
          </ListWeekContainer>
        );
      case props.view.type === 'timeGridWeek':
        return (
          <Container>
            <WeekDay $isToday={props.isToday} $isPast={props.isPast}>
              {days[props.date.getDay()]}
            </WeekDay>
            <MonthDayWrapper $isToday={props.isToday} $isPast={props.isPast}>
              <MonthDay>{props.date.getDate()}</MonthDay>
            </MonthDayWrapper>
          </Container>
        );
      default:
        return (
          <Container>
            <WeekDay $isToday={props.isToday} $isPast={props.isPast}>
              {props?.text?.toUpperCase()}
            </WeekDay>
          </Container>
        );
    }
  };
  return renderDayHeader();
};

export default DayHeader;
